import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';

import { startAddBid } from '../../../store/actions/bids';
import { startEditAdmin } from '../../../store/actions/admin';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 700,
  },
});

const BidsTable = ({ classes, bids, startAddBid, startEditAdmin }) => {
  return (
    <Paper className={classes.root}>
      <Button
        variant="raised"
        onClick={() => (
          startAddBid({
            code: "test"
          })
        )}>Create</Button>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>bidNumber</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {bids.map(bid => {
            return (
              <TableRow key={bid.id}>
                <TableCell>{bid.bidNumber}</TableCell>
                <TableCell numeric>
                  <Button onClick={() => startEditAdmin({bid: bid})}>
                    View
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
}

BidsTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return { bids: state.bidsState };
};

const mapDispatchToProps = (dispatch) => ({
  startAddBid: (bid) => dispatch(startAddBid(bid)),
  startEditAdmin: (bid) => dispatch(startEditAdmin(bid))
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(BidsTable);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/BidsTable.jsx